import { render, staticRenderFns } from "./SelectableBoxes.vue?vue&type=template&id=6f5cb275&scoped=true"
import script from "./SelectableBoxes.vue?vue&type=script&lang=js"
export * from "./SelectableBoxes.vue?vue&type=script&lang=js"
import style0 from "./SelectableBoxes.vue?vue&type=style&index=0&id=6f5cb275&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5cb275",
  null
  
)

export default component.exports